module.exports = __webpack_public_path__ + "img/SKMJ_saferoad6.5a8e824a.jpg";